import React from 'react';
import { makeStyles, Grid, useTheme } from '@material-ui/core';
import casatravel from '../../assets/images/casatravel.jpg';
import casaforex from '../../assets/images/casaforex.jpg';
import alghuraba from '../../assets/images/alghuraba.jpg';
// import TitleText from '../reusableComponents/TitleText';
// import HeadlineText from '../reusableComponents/HeadlineText';

const useStyles = makeStyles((theme) => ({
	mainContainer: {
		marginTop: '5%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		[theme.breakpoints.up('sm')]: {
			marginTop: '6%',
		},
		[theme.breakpoints.up('xl')]: {
			marginTop: '4%',
		},
	},
	titleTextcontainer: {
		marginBottom: 16,
		textAlign: 'center',
		[theme.breakpoints.down('sm')]: {
			textAlign: 'center',
		},
	},
	imagesContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '95%',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '2%',
		[theme.breakpoints.up('sm')]: {
			width: '65%',
		},
	},
	image: {
		objectFit: 'contain',
		width: '100%',
		height: 200,
	},
}));

const TechnologyPartnersSection = () => {
	const classes = useStyles();
	const theme = useTheme();
	const content = {
		title: 'Companies',
		subtitle: 'Brand Partners',
		partners: [casatravel, casaforex, alghuraba],
	};
	return (
		<Grid className={classes.mainContainer}>
			<Grid className={classes.titleTextcontainer}>
				{/* <TitleText textStyle={{ color: theme.palette.primary.main }} two> */}
				<span>{content.title}</span>

				{/* </TitleText> */}
			</Grid>
			<Grid className={classes.titleTextcontainer}>
				<h1>{content.subtitle}</h1>
			</Grid>
			<Grid className={classes.imagesContainer}>
				{content.partners.map((partner, index) => {
					return (
						<Grid key={index} style={{ marginLeft: index === 0 ? '' : 35 }}>
							<img
								src={partner}
								alt={`tech-partner-${index}`}
								className={classes.image}
							/>
						</Grid>
					);
				})}
			</Grid>
		</Grid>
	);
};

export default TechnologyPartnersSection;
